import { useLanguage } from '@/contexts/LanguageContext';

const SECTIONS = [
  { id: 'slogan', key: 'slogan' },
  { id: 'quem-somos', key: 'quemSomos' },
  { id: 'proposito', key: 'proposito' },
  { id: 'produtos', key: 'produtos' },
  { id: 'contato', key: 'contato' },
];

export default function NavigationDots({ activeSection }) {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      data-testid="navigation-dots"
      className="fixed right-6 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col items-end gap-4"
    >
      {SECTIONS.map((section) => {
        const isActive = activeSection === section.id;
        return (
          <button
            key={section.id}
            data-testid={`nav-dot-${section.id}`}
            onClick={() => scrollTo(section.id)}
            className="group flex items-center gap-3"
            aria-label={t.sections[section.key]}
            aria-current={isActive ? 'true' : undefined}
          >
            {/* Label on hover */}
            <span
              className={`text-xs font-light tracking-wider transition-all duration-300 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 ${
                isActive ? 'text-[#35589B]' : 'text-[#333333]/70'
              }`}
            >
              {t.sections[section.key]}
            </span>
            {/* Dot */}
            <div
              className={`rounded-full transition-all duration-300 ${
                isActive
                  ? 'w-3 h-3 bg-[#35589B]'
                  : 'w-2 h-2 bg-[#333333]/20 group-hover:bg-[#333333]/40'
              }`}
            />
          </button>
        );
      })}
    </div>
  );
}
